
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Innovacrystaonrentinpune() {



    const cardData =
    {
        keyword: 'Innova Crysta on Rent in Pune',
        heading: 'Meghana Cab : Innova Crysta on Rent in Pune',
        headingDescription: 'Meghana Cab offers Innova Crysta on Rent in Pune, perfect for those seeking spacious, premium, and comfortable travel on short trips or full-day excursions. Our Innova Crysta vehicles come with plush leather seats, ample legroom, and large luggage space—ideal for family outings, corporate travel, airport pickups, or outstation tours. With experienced drivers, well-maintained cars, transparent hourly or fixed-day pricing, and 24/7 customer support, we ensure a hassle-free and enjoyable experience. Book your Innova Crysta on Rent in Pune with Meghana Cab for a smooth, stylish, and reliable journey tailored to your schedule and needs.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
   {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

     "services": [
    {
      "name": "Rent Innova Crysta in Pune",
      "description": "Rent an Innova Crysta in Pune for luxurious, spacious, and comfortable travel across the city or to nearby destinations. Ideal for families, corporate groups, and outstation trips, the vehicle offers superior ride quality, ample legroom, and a smooth driving experience with our professional chauffeurs."
    },
    {
      "name": "Innova Crysta Hire Pune for Outstation",
      "description": "Planning an outstation journey from Pune? Hire our well-maintained Innova Crysta for long-distance travel. The SUV is perfect for hill stations, weekend getaways, or multi-day tours, offering a combination of power, safety, and comfort on every route."
    },
    {
      "name": "AC Innova Crysta on Rent Pune",
      "description": "Travel in style and beat the heat with our fully air-conditioned Innova Crysta rental service in Pune. Whether it’s for local travel or longer trips, our AC Innova ensures a pleasant ride with climate control and plush interiors."
    },
    {
      "name": "SUV Rental Innova Crysta Pune",
      "description": "Choose Innova Crysta for SUV rental in Pune to enjoy a high-performance ride with generous cabin space. It's ideal for corporate events, airport transfers, and long drives with comfort and reliability."
    },
    {
      "name": "Online Booking Innova Crysta Pune",
      "description": "Book your Innova Crysta online in Pune with ease. Our platform allows quick reservations, flexible pickup points, and transparent pricing—making your booking process seamless and secure."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune",
      "description": "Sit back and relax while our trained and courteous chauffeurs drive you in a top-notch Innova Crysta across Pune or to outstation locations. Safety, punctuality, and comfort are our top priorities."
    },
    {
      "name": "Corporate Trip Innova Crysta Hire Pune",
      "description": "Elevate your business travel with our corporate Innova Crysta hire service in Pune. With executive seating and a premium ride, it’s perfect for airport pickups, client visits, or team travel."
    },
    {
      "name": "Wedding Car Innova Crysta Pune",
      "description": "Add a touch of class to your wedding logistics with our wedding Innova Crysta hire in Pune. Ideal for guest transportation or family travel, the vehicle offers comfort, style, and punctual service."
    },
    {
      "name": "Family Travel Innova Crysta Rental Pune",
      "description": "Make your family trip stress-free and enjoyable with our Innova Crysta rental in Pune. The spacious 6-seater is ideal for group travel, providing ample luggage space, AC, and a smooth ride."
    },
    {
      "name": "Premium Innova Crysta Taxi Pune",
      "description": "Opt for our premium Innova Crysta taxi services in Pune for a touch of luxury. Perfect for executives, VIPs, or those who seek extra comfort and amenities during their journey."
    },
    {
      "name": "Daily Rental Innova Crysta Pune",
      "description": "Need a vehicle for the day? Our daily rental Innova Crysta service in Pune gives you flexible packages for city use, sightseeing, or business meetings—all with transparent pricing."
    },
    {
      "name": "Long Drive Innova Crysta Hire Pune",
      "description": "Planning a long drive from Pune? Hire an Innova Crysta for unmatched comfort, superior suspension, and reliability over extended distances. Ideal for road trips with family or friends."
    },
    {
      "name": "Airport Transfer Innova Crysta Pune",
      "description": "Ensure timely and comfortable airport transfers in Pune with our Innova Crysta service. Great for corporate clients, families, and groups with luggage, available for pickup or drop 24/7."
    },
    {
      "name": "Comfortable 6-Seater Innova Crysta Pune",
      "description": "Our 6-seater Innova Crysta rentals in Pune are designed for comfort, with captain seats, ample legroom, and modern amenities for relaxed city and highway journeys."
    },
    {
      "name": "24/7 Innova Crysta Booking Pune",
      "description": "Book an Innova Crysta in Pune anytime, day or night. Our 24/7 availability ensures that your travel needs are covered round the clock with prompt confirmations and dependable service."
    }
  ],
  "tableData": [
    ["Rent Innova Crysta in Pune", "Innova Crysta Hire Pune for Outstation"],
    ["AC Innova Crysta on Rent Pune", "SUV Rental Innova Crysta Pune"],
    ["Online Booking Innova Crysta Pune", "Chauffeur Driven Innova Crysta Pune"],
    ["Corporate Trip Innova Crysta Hire Pune", "Wedding Car Innova Crysta Pune"],
    ["Family Travel Innova Crysta Rental Pune", "Premium Innova Crysta Taxi Pune"],
    ["Daily Rental Innova Crysta Pune", "Long Drive Innova Crysta Hire Pune"],
    ["Airport Transfer Innova Crysta Pune", "Comfortable 6-Seater Innova Crysta Pune"],
    ["24/7 Innova Crysta Booking Pune", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Premium Innova Crysta on Rent in Pune",
        "WhyChoosedescription": "Rent a spacious and luxurious Innova Crysta in Pune for city rides, outstation trips, or airport transfers. Whether you're traveling with family, on a business tour, or planning a group trip, the Innova Crysta offers unmatched comfort, reliability, and elegance."
    },
    {
        "WhyChooseheading": "Spacious and Luxurious Interiors",
        "WhyChoosedescription": "The Toyota Innova Crysta is known for its ample legroom, plush captain seats, premium upholstery, and top-notch interior design. It's perfect for long journeys where passenger comfort is a top priority—accommodating up to 6 or 7 passengers comfortably."
    },
    {
        "WhyChooseheading": "Ideal for Long-Distance and Group Travel",
        "WhyChoosedescription": "Whether you're heading to Mumbai, Mahabaleshwar, Shirdi, or Goa, the Innova Crysta offers a powerful engine, smooth ride quality, and ample luggage space—making it the preferred choice for outstation trips, family vacations, and corporate travel."
    },
    {
        "WhyChooseheading": "Professional Drivers and Timely Service",
        "WhyChoosedescription": "Our Innova Crysta rentals come with experienced, courteous, and professionally trained drivers who prioritize your safety and punctuality. They are familiar with all major city routes and highways, ensuring a smooth journey every time."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Every Innova Crysta in our fleet is routinely serviced, thoroughly cleaned, and fully air-conditioned to guarantee comfort and safety. We sanitize vehicles before every trip, ensuring a hygienic environment for you and your co-passengers."
    },
    {
        "WhyChooseheading": "Flexible Rental Options – Hourly, Daily, and Outstation",
        "WhyChoosedescription": "Choose from a variety of rental plans—whether you need the vehicle for a few hours within Pune, a full day, or multiple days for outstation travel. Our flexible packages cater to all kinds of travel plans with competitive pricing."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "We offer clear, upfront pricing with no hidden costs. Your rental fare includes driver charges, fuel (if applicable), tolls, and taxes. Get value for money with top-tier service and a premium travel experience."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Book your Innova Crysta in Pune anytime—day or night—through our easy online platform or by contacting our customer support team. We’re available 24/7 to help with reservations, changes, or travel assistance."
    }
]















    }

const faqData = [
    {
        question: "How can I rent an Innova Crysta in Pune?",
        answer: "You can rent an Innova Crysta by calling Meghana Cab at +91 9075462128 or booking online through our website."
    },
    {
        question: "What is the seating capacity of the Innova Crysta?",
        answer: "The Innova Crysta comfortably seats 6 to 7 passengers, ideal for family or group travel."
    },
    {
        question: "Is the Innova Crysta rental available for local and outstation trips?",
        answer: "Yes, you can rent the Innova Crysta for both local rides within Pune and outstation journeys."
    },
    {
        question: "Are the Innova Crysta vehicles well-maintained and sanitized?",
        answer: "Absolutely. All Innova Crysta cars are regularly serviced and sanitized before every trip for your safety."
    },
    {
        question: "Is the Innova Crysta rental service available 24/7 in Pune?",
        answer: "Yes, Meghana Cab offers round-the-clock Innova Crysta rental services."
    },
    {
        question: "What is included in the rental fare for Innova Crysta in Pune?",
        answer: "The fare includes fuel, tolls, and driver charges. Additional waiting or parking fees may apply."
    },
    {
        question: "Can I book an Innova Crysta on short notice?",
        answer: "Yes, last-minute bookings are accepted based on availability."
    },
    {
        question: "What payment methods are accepted for Innova Crysta rentals?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "Can I request stops for meals or sightseeing during the trip?",
        answer: "Yes, stops can be arranged upon request. Please inform us when booking."
    },
    {
        question: "Are the drivers experienced in handling the Innova Crysta?",
        answer: "Yes, our drivers are skilled and experienced to ensure a safe and comfortable journey."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Rahul Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Renting an Innova Crysta from Meghana Cab in Pune was a wonderful experience. The vehicle was clean and the driver was professional.”',
    },
    {
        name: 'Ms. Ananya Desai',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Comfortable ride and excellent service. Highly recommend Meghana Cab for Innova Crysta rentals in Pune.”',
    },
];




































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta on Rent in Pune",
  "image": "https://www.meghanacabs.com/assets/images/innova-crysta-rental-pune.jpg",
  "description": "Rent an Innova Crysta in Pune for outstation trips, airport transfers, weddings, and corporate travel. Enjoy comfortable 6-seater AC SUV with professional chauffeurs available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4321"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/innova-crysta-rent-pune"
  }
};







    return (
        <div>

<Helmet>
  <title>Innova Crysta on Rent in Pune | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Rent an Innova Crysta in Pune for outstation trips, airport transfers, weddings, and corporate travel. Enjoy comfortable 6-seater AC SUV with professional chauffeurs available 24/7." 
  />
  <meta 
    name="keywords" 
    content="Rent Innova Crysta in Pune, Innova Crysta Hire Pune for Outstation, AC Innova Crysta on Rent Pune, SUV Rental Innova Crysta Pune, Online Booking Innova Crysta Pune, Chauffeur Driven Innova Crysta Pune, Corporate Trip Innova Crysta Hire Pune, Wedding Car Innova Crysta Pune, Family Travel Innova Crysta Rental Pune, Premium Innova Crysta Taxi Pune, Daily Rental Innova Crysta Pune, Long Drive Innova Crysta Hire Pune, Airport Transfer Innova Crysta Pune, Comfortable 6-Seater Innova Crysta Pune, 24/7 Innova Crysta Booking Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/54.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystaonrentinpune;